export const UNSUBSCRIBE_REQUEST = 'UNSUBSCRIBE_REQUEST';
export const UNSUBSCRIBE_REQUEST_DONE = 'UNSUBSCRIBE_REQUEST_DONE';
export const UNSUBSCRIBE_REQUEST_ERROR = 'UNSUBSCRIBE_REQUEST_ERROR';
export const UNSUBSCRIBE_REQUEST_RESET = 'UNSUBSCRIBE_REQUEST_RESET';
//# sourceMappingURL=actionTypes.js.map